import request from 'utils/request';

const PREFIX = '/api/adv-receipt-claim/';

export const AdvReceiptClaimAPI = {
  LIST: PREFIX + 'list',
  ADD: PREFIX + 'add',
  CLAIM: PREFIX + 'claiming',
  PREVIEW: PREFIX + 'preview',
  CONFIRM: PREFIX + 'confirm',
};

export function getAdvReceiptClaimList(data) {
  return request({
    url: AdvReceiptClaimAPI.LIST,
    method: 'post',
    data,
  });
}

export function addAdvReceiptClaim(data) {
  return request({
    url: AdvReceiptClaimAPI.ADD,
    method: 'post',
    data,
  });
}

export function doAdvReceiptClaim(data) {
  return request({
    url: AdvReceiptClaimAPI.CLAIM,
    method: 'post',
    data,
  });
}

export function confirmAdvReceiptClaim(data) {
  return request({
    url: AdvReceiptClaimAPI.CONFIRM,
    method: 'post',
    data,
  });
}

export function getAdvReceiptClaimPreviewData(data) {
  return request({
    url: AdvReceiptClaimAPI.PREVIEW,
    method: 'post',
    data,
  });
}
